import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Utils } from 'src/app/utils/utils';

export interface ChangeHistoryEntry {
    field: string;
    oldValue: string;
    newValue: string;
    user: string;
    UTCDate: string;
}

@Component({
    selector: 'dialog-change-history',
    templateUrl: './dialog-change-history.html',
    styleUrls: ['./dialog-change-history.less',
        '../../../style/changelog-dialog/changelog-dialog.less'],
    standalone: false
})
export class ChangeHistoryDialogue implements OnInit {
    public dataSource = new MatTableDataSource<ChangeHistoryEntry>();
    columnsToDisplay = ['UTCDate', 'user', 'field', 'oldValue', 'newValue' ];
    @ViewChild('tableBody') tableBody!: ElementRef;

    filterValues: any = {
        field: '',
        oldValue: '',
        newValue: '',
        user: '',
        startDate: null,
        endDate: null
    };
    originalData: ChangeHistoryEntry[] = [];

    constructor(
        private dialogRef: MatDialogRef<ChangeHistoryDialogue>,
        // @Inject(MAT_DIALOG_DATA) public data: { changes: ChangeHistoryDialogue[] },
        // @Inject(MAT_DIALOG_DATA) public data: { entity: string, tenantId: string, UId: string },
        @Inject(MAT_DIALOG_DATA) public data: { entity: string, row: any, subrow: any[] },
        @Inject('BASE_URL') private baseUrl: string,
        private http: HttpClient,
        public datePipe: DatePipe
    ) {}


    ngOnInit(): void {
        const { entity, row } = this.data;
        Utils.httpPostAuditChangeLog(
            this.http,
            this.baseUrl,
            entity,
            row,
            this,
            (logs: any[]) => {
                const mappedLogs = logs.map(log => ({
                    field: log.fieldName,
                    oldValue: log.oldValue,
                    newValue: log.newValue,
                    UTCDate: log.timestamp,
                    user: log.modifiedBy
                }));
                this.originalData = mappedLogs;
                this.dataSource.data = mappedLogs;
            }
        );
    }

    applyFilter() {
        this.dataSource.data = this.originalData.filter(row => {
            const matchesField = this.filterValues.field === '' || (row.field || '').toLowerCase().includes(this.filterValues.field.toLowerCase());
            const matchesOldValue = this.filterValues.oldValue === '' || (row.oldValue || '').toLowerCase().includes(this.filterValues.oldValue.toLowerCase());
            const matchesNewValue = this.filterValues.newValue === '' || (row.newValue || '').toLowerCase().includes(this.filterValues.newValue.toLowerCase());
            const matchesUser = this.filterValues.user === '' || (row.user || '').toLowerCase().includes(this.filterValues.user.toLowerCase());

            // Date filtering
            let matchesStart = true, matchesEnd = true;
            if (this.filterValues.startDate) {
                matchesStart = new Date(row.UTCDate) >= new Date(this.filterValues.startDate);
            }
            if (this.filterValues.endDate) {
                // Add 1 day to include the end date fully
                const end = new Date(this.filterValues.endDate);
                end.setHours(23,59,59,999);
                matchesEnd = new Date(row.UTCDate) <= end;
            }

            return matchesField && matchesOldValue && matchesNewValue && matchesUser && matchesStart && matchesEnd;
        });
    }

    close() {
        this.dialogRef.close();
    }
}